import React, { createContext, useState } from 'react'

import { Modal } from 'antd'
import { useSelector } from 'react-redux'
import { isFunction, isObject } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { selectUser } from '../../../reducers/UserReducer'
import StudentForm, { Types } from './StudentForm'
import { Permissions } from './SearchStudentModalProvider'
import FormFooter from '../../../Components/antd/Forms/FormFooter'
import { StudentValidators } from '../../../utils/entities/student'
import { isValid } from '../../../utils/validators'
import { isOptimistic } from '../../../utils'
import { createStudent, updateStudent } from '../../../utils/api/student'
import { onError, onSuccess, onWarning } from '../../../utils/apiHelper'

export const StudentFormModalContext = createContext()

const DEFAULT_FORM_HANDLER = { data: null, callback: null, mode: null }

const StudentFormModal = ({ children, sectors = [], keysToValidate = [] }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [formHandler, setFormHandler] = useState(DEFAULT_FORM_HANDLER)
  const [errorFields, setErrorFields] = useState([])

  const handleSubmit = () => {
    const errors = isValid(formHandler.data, Object.values(StudentValidators))

    if (errors.keys.length === 0) {
      let promise
      let action

      if (isOptimistic(formHandler.data)) {
        promise = createStudent(user, formHandler.data.toRequestBody())
        action = 'create'
      } else {
        promise = updateStudent(user, formHandler.data, formHandler.data.toRequestBody())
        action = 'update'
      }

      promise.then(({ data }) => {
        if (isFunction(formHandler.callback)) {
          formHandler.callback(data, action)
        }

        setFormHandler(DEFAULT_FORM_HANDLER)
        onSuccess(t(`student.${action}.success`))

        if (action === 'create' && data.sections.length > 1) {
          onWarning(t('student.create.warning.multiple_schools'))
        }
      }).catch(error => {
        onError(t(`student.${action}.error`))
        console.error(error)
      })
    } else {
      setErrorFields(errors.keys)
    }
  }

  return (
    <>
      <StudentFormModalContext.Provider value={{ setFormHandler }}>
        {children}
      </StudentFormModalContext.Provider>
      <Modal
        className='form-modal'
        title={t('student_form.title.' + (isOptimistic(formHandler.data) ? 'create' : 'update'))}
        visible={isObject(formHandler.data)}
        onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
        destroyOnClose
        footer={null}
      >
        <div className='pdl-16 pdr-16'>
          {isObject(formHandler.data) && (
            <StudentForm
              data={formHandler.data}
              errorFields={errorFields}
              permission={Permissions.GOD}
              type={Types.STUDENT}
              onChange={data => setFormHandler(form => ({ ...form, data }))}
            />
          )}
        </div>
        <FormFooter
          cancel={{ text: t('modal.cancel_button') }}
          remove={null}
          submit={{ text: t('modal.ok_button.save') }}
          onSubmit={handleSubmit}
          onCancel={() => setFormHandler(DEFAULT_FORM_HANDLER)}
        />
      </Modal>
    </>
  )
}

export default StudentFormModal
